import React from 'react'

export const Services = () => {
  return (
    <div className="page">
      <h1 className="page-title">Servicios</h1>
      <section className="services">
          <article className="service">
            <h2 className="page-subtitle">Diseño web</h2>
            <p>Creacion y mejora de la apariencia de tu sitio web para que sea mas atractiva.</p>
          </article>

          <article className="service">
            <h2 className="page-subtitle">Desarrollo web</h2>
            <p>Diseño, creación e implementación de tu sitio web desde cero.</p>
          </article>

          <article className="service">
            <h2 className="page-subtitle">Posicionamiento en la web</h2>
            <p>Hago que tu sitio tenga mas visibilidad en Google y sea accesible a más público.</p>
          </article>
      </section>
    </div>
  )
}
